module.exports = __webpack_public_path__ + "media/images/thumbs/biology/q_quiz_dicot_leaf_1-5780c8a165fc871b1ab0d93071caa5ac.jpg";